import { FC, ReactNode, PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material';
import { heroScreenStyles } from './hero-screen.styles';
import { useStyles, clsx } from '@sweatpals/react-ui-kit';

export interface HeroScreenProps extends PropsWithChildren {
	twoSided?: boolean;
	background?: ReactNode;
	rootSx?: SxProps<Theme>;
	foregroundSx?: SxProps<Theme>;
	backgroundSx?: SxProps<Theme>;
}

const HeroScreen: FC<HeroScreenProps> = ({ rootSx, twoSided, foregroundSx, backgroundSx, children, background }) => {
	const styles = useStyles(heroScreenStyles, twoSided);

	return (
		<Box sx={clsx(styles.root, rootSx)}>
			<Box sx={clsx(styles.background, backgroundSx)}>{background}</Box>
			<Box sx={clsx(styles.foreground, foregroundSx)}>{children}</Box>
		</Box>
	);
};

export default HeroScreen;
